shadow$provide[374] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec2 vClipEnds;

void clipEndsFragment() {
  if (vClipEnds.x < 0.0 || vClipEnds.y < 0.0) discard;
}
`;

};